import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export async function downloadReferentialExport() {
  try {
    const r = await api.get("/stops/export.xlsx", { responseType: "blob" });
    const cd = r.headers["content-disposition"] || "";
    const m = cd.match(/filename="?([^"]+)"?/);
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = m ? m[1] : "LOGIBUS_referentiel.xlsx";
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    toast.success("Export Excel généré");
  } catch (e) {
    toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Export impossible");
  }
}
